/* ============================================================
   Duendes — OMT overlay "Dejá que uno te elija" (rediseño claro y aireado)
   - Lee un POOL de productos EN STOCK renderizado por Liquid en
     <script type="application/json" id="air-omt-pool"> (datos reales).
   - El overlay se abre SOLO al tocar el botón [data-omt="open"].
   - Liviano, vanilla, diferido. Delegación de eventos.
   ============================================================ */
(function () {
  if (window.__airOmtInit) return;
  window.__airOmtInit = true;

  function boot() {
    var poolEl = document.getElementById('air-omt-pool');
    var POOL = [];
    if (poolEl) {
      try { POOL = JSON.parse(poolEl.textContent) || []; } catch (e) { POOL = []; }
    }
    var isEs = (document.documentElement.lang || 'es').toLowerCase().indexOf('en') !== 0;
    var last = -1, filt = null, moved = false;

    function intentLabel(it) {
      if (!it) return '';
      if (isEs) {
        var fem = ['Abundancia', 'Suerte', 'Calma', 'Sanación', 'Protección'];
        var art = (it === 'Amor') ? 'del' : 'de la';
        // grammar: "Guardián de la Protección" / "Guardián del Amor"
        return 'Guardián ' + art + ' ' + it;
      }
      return 'Guardian of ' + it;
    }

    function pick() {
      var c = POOL.filter(function (d) { return !filt || d.i === filt; });
      if (!c.length) return null; // filtro activo sin match (o pool vacío) → mensaje lindo
      var d, g = 0;
      do { d = c[Math.floor(Math.random() * c.length)]; g++; }
      while (c.length > 1 && POOL.indexOf(d) === last && g < 12);
      last = POOL.indexOf(d);
      return d;
    }

    function render(d) {
      var rv = document.getElementById('air-reveal');
      if (!rv) return;
      if (!d) {
        // sin stock para esa intención → mensaje lindo
        rv.style.display = 'block';
        rv.querySelector('[data-r=name]').textContent = isEs ? 'Justo ninguno ahora' : 'None right now';
        rv.querySelector('[data-r=intent]').textContent = '';
        rv.querySelector('[data-r=story]').textContent = isEs
          ? 'No hay uno disponible con esa intención en este momento. Probá otra, o que se presente cualquiera ✦'
          : 'None available with that intention right now. Try another, or let any one show up ✦';
        var img0 = rv.querySelector('[data-r=img]'); if (img0) img0.removeAttribute('src');
        var mine0 = rv.querySelector('[data-r=mine]'); if (mine0) mine0.style.display = 'none';
        return;
      }
      var img = rv.querySelector('[data-r=img]');
      if (img) img.src = d.img + (d.img.indexOf('?') > -1 ? '&' : '?') + 'width=700';
      rv.querySelector('[data-r=name]').textContent = d.n;
      rv.querySelector('[data-r=intent]').textContent = d.il || intentLabel(d.i);
      rv.querySelector('[data-r=story]').textContent = d.s || '';
      var mine = rv.querySelector('[data-r=mine]');
      if (mine) { mine.style.display = ''; mine.href = d.url || '#'; }
      rv.style.display = 'block';
    }

    document.addEventListener('click', function (e) {
      var t = e.target.closest('[data-omt]');
      if (!t) return;
      var a = t.getAttribute('data-omt');
      var modal = document.getElementById('air-omt-modal');
      if (!modal) return;

      if (a === 'open') {
        e.preventDefault();
        if (!moved) { document.body.appendChild(modal); moved = true; }
        modal.classList.add('is-open');
        document.body.style.overflow = 'hidden';
      } else if (a === 'close') {
        modal.classList.remove('is-open');
        document.body.style.overflow = '';
      } else if (a === 'reveal' || a === 'another') {
        render(pick());
      } else if (a === 'chip') {
        var v = t.getAttribute('data-intent');
        var on = t.getAttribute('data-on') === '1';
        [].forEach.call(modal.querySelectorAll('[data-omt=chip]'), function (c) { c.setAttribute('data-on', '0'); });
        if (on) { filt = null; }
        else { t.setAttribute('data-on', '1'); filt = (v === '*') ? null : v; }
      } else if (a === 'tut') {
        var idx = +t.getAttribute('data-i');
        var tr = document.getElementById('air-tut');
        if (tr) tr.scrollTo({ left: idx * tr.clientWidth, behavior: 'smooth' });
        setDots(idx);
      }
    });

    // backdrop click closes
    var modalEl = document.getElementById('air-omt-modal');
    if (modalEl) {
      modalEl.addEventListener('click', function (e) {
        if (e.target === modalEl) {
          modalEl.classList.remove('is-open');
          document.body.style.overflow = '';
        }
      });
    }
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modalEl && modalEl.classList.contains('is-open')) {
        modalEl.classList.remove('is-open');
        document.body.style.overflow = '';
      }
    });

    function setDots(idx) {
      var dots = document.querySelectorAll('#air-omt-modal .air-dot');
      [].forEach.call(dots, function (d, i) { d.classList.toggle('is-on', i === idx); });
    }
    // sync dots on swipe
    var track = document.getElementById('air-tut');
    if (track) {
      var deb;
      track.addEventListener('scroll', function () {
        clearTimeout(deb);
        deb = setTimeout(function () {
          var idx = Math.round(track.scrollLeft / track.clientWidth);
          setDots(idx);
        }, 60);
      }, { passive: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
